import script from "./Detail-pdf.vue?vue&type=script&setup=true&lang=js"
export * from "./Detail-pdf.vue?vue&type=script&setup=true&lang=js"

import "./Detail-pdf.vue?vue&type=style&index=0&id=81aa4312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81aa4312"]])

export default __exports__